import { render, staticRenderFns } from "./WelfareMallHotelOrder.vue?vue&type=template&id=3915c377&scoped=true"
import script from "./WelfareMallHotelOrder.vue?vue&type=script&lang=js"
export * from "./WelfareMallHotelOrder.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallHotelOrder.vue?vue&type=style&index=0&id=3915c377&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3915c377",
  null
  
)

export default component.exports